<template>
  <div class="content">
    <div class="header text-center">
      <h3 class="title">Timeline</h3>
    </div>
    <div class="row">
      <div class="col-md-12">
        <!-- {{tableItems}} -->
        <time-line>
          <time-line-item
            v-for="(item, i) in tableItems"
            :key="i"
            :inverted="i % 2 == 0"
            :badge-type="getBadgeType(i)"
            badge-icon="tim-icons icon-paper"
          >
            <span
              slot="header"
              :class="`badge badge-pill badge-${getBadgeType(i)}`"
            >
              {{ item.occurrenceDescription }}
            </span>

            <span
              v-if="item.hasAttachment"
              slot="header"
              :class="`badge badge-pill badge-${getBadgeType(i)} button-anexo`"
            >
              <a
                href="#"
                @click.prevent="openImage(item.occurrencyId)"
                style="color: white"
              >
                <i class="tim-icons icon-camera-18"></i>
              </a>
            </span>

            <p slot="content">{{ item.occurrenceDescription }}</p>
            <h6 slot="footer">
              {{ getFormattedDateTime(item.occurrenceDate) }}
              <a
                slot="footer"
                class="colorIcon"
                href="#"
                @click="openModal(item)"
                title="Localização"
                v-b-tooltip.hove
              >
                <i class="tim-icons icon-square-pin"></i>
              </a>
            </h6>
          </time-line-item>
        </time-line>
      </div>
    </div>
    <!-- <div>{{tableItems}}</div> -->
    <fullscreen-sidebar ref="fullscreenSidebar">
      <template v-slot:content>
        <img :src="attachmentUrl" class="fullscreen-sidebar-img" />
      </template>
    </fullscreen-sidebar>

    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      title="Localização"
    >
      <div v-if="latitude == 0 && longitude == 0">
        <h4 class="danger">Essa ocorrência não possui localização</h4>
      </div>
      <base-map :apiKey="apiKey" :pin="pin"> </base-map>
      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="green" @click="ok()"> Fechar </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { TimeLine, TimeLineItem } from "src/components";
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";

export default {
  name: "TrackingClientTimeLine",
  props: {
    id: String,
  },
  components: {
    "fullscreen-sidebar": FullscreenSidebar,
    TimeLine,
    TimeLineItem,
    BaseMap: () => import("@/components_rms/base/BaseMap.vue"),
  },
  created() {
    this.pin.location.longitude = this.longitude;
    this.pin.location.latitude = this.latitude;
  },
  data: function () {
    return {
      attachmentUrl: "",
      occurrency: null,
      tableItems: [],
      apiKey:
        "As-Vkf2McY-jBXfx3q_vrpwdrFmtyixvHjGFuv90Ak2WD338py0sIQ7wCf5z2D80", //chave da api
      pin: {
        key: "pin1",
        location: {
          latitude: 0,
          longitude: 0,
        },
        visible: true,
      },
      latitude: 0,
      longitude: 0,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    openModal(item) {
      console.log(item);
      this.latitude = item.latitude;
      this.longitude = item.longitude;
      this.$refs.openModal.show();
    },
    getBadgeType(i) {
      if (i & 1) {
        return "info";
      }
      return "danger";
    },
    getFormattedDateTime(value) {
      if (value) {
        let date = new Date(value);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
      }
      return "";
    },
    openImage(occurrency) {
      console.log(`openImg ${occurrency}`);
      this.attachmentUrl = "";
      this.occurrency = occurrency;
      this.loadImg();
      this.$refs.fullscreenSidebar.open();
    },
    async loadData() {
      this.$api
        .get(`/v1/deliveryClient/occurrences/${this.id}`)
        .then((response) => {
          this.tableItems = response.data;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          if (err.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    async loadImg() {
      if (this.occurrency) {
        this.$api
          .request({
            url: `${this.$store.state.urlTracking}/v1/deliveryClient/attachment/${this.id}/${this.occurrency}`,
            method: "GET",
            responseType: "arraybuffer", //important
          })
          .then((response) => {
            this.attachmentUrl = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              console.log(error.response.data.errors);
            }
          });
      }
      return "";
    },
  },
  watch: {
    latitude() {
      if (this.latitude != 0) this.pin.location.latitude = this.latitude;
    },
    longitude() {
      if (this.longitude != 0) this.pin.location.longitude = this.longitude;
    },
  },
};
</script>
<style scoped>
.fullscreen-sidebar-img {
  /* zoom: 2; increase if you have very small images */
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin: auto;
  height: auto;
  max-height: 100%;
  width: auto;
  max-width: 100%;
}
.colorIcon {
  margin-left: 5%;
  color: white !important;
}

.danger {
  color: #fd5d93 !important;
}
</style>
